<template>
  <div class="cm-contacts-edit-form">
    <Box :title="title" :showClose="!container" @close="$emit('close')">
    <div :class="['cm-form', {container: container}]">
      <transition name="fade">
        <div v-if="loading > 0" class="cm-loader">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </transition>
      <div class="cm-form-details">
        <v-text-field v-model="contact.firstName" :readonly="readonly" placeholder="forename" />
        <v-text-field v-model="contact.lastName" :readonly="readonly" placeholder="surname" />
        <v-text-field v-model="contact.email" :readonly="readonly" placeholder="email" />
        <v-text-field v-model="contact.mobile" :readonly="readonly" placeholder="home phone" />
        <v-text-field v-model="contact.telephone" :readonly="readonly" placeholder="mobile" />

        <div class="cm-contact-list-actions">
          <v-btn v-if="!readonly" color="primary" :disabled="loading > 0" @click="save">{{contact.id ? 'Update' : 'Create'}}</v-btn>
        </div>
      </div>
    </div>
    </Box>
  </div>
</template>

<script>
import { createContact, updateContact } from "@/services/API"
import Box from "@/components/general/Box"
import { mapState } from "vuex"
import { Logger } from "aws-amplify"
const logger = new Logger("+++ contacts/form")

export default {
  components: { Box },

  props: {
    edit: {
      type: [Boolean, Object],
      required: true
    },

    readonly: {
      type: Boolean,
      default: () => false
    },

    container: {
      type: Boolean,
      default: () => false
    }
  },

  data () {
    return {
      contact: {
        id: false,
        firstName: '',
        lastName: '',
        telephone: '',
        mobile: '',
        type: 'external',
        email: '',
        tags: []
      },

      loading: 0
    }
  },

  computed: {
    ...mapState(["org"]),
    contactFormatted () {
      return {
        firstName: this.contact.firstName,
        lastName: this.contact.lastName,
        telephone: this.contact.telephone,
        mobile: this.contact.mobile,
        email: this.contact.email,
        tags: []
      }
    },
    title () {
      return this.contact.id 
        ? this.readonly
          ? 'View contact'
          : 'Edit contact'
        : 'Create contact'
    }
  },

  watch: {
    edit (val) {
      if(val) {
        this.contact = JSON.parse(JSON.stringify(val))
      } 
    }
  },

  methods: {
    async save () {
      this.loading++
      logger.debug("save", this.contact)

      
      if(!this.contact.id) {
        const result = await createContact(this.org.id, this.contactFormatted)
        if(result) {
          this.contact.id = result.Contact.id
          this.$emit("updated")
        }
      } else {
        const result = await updateContact(this.org.id, this.contactFormatted, this.contact.id)
         if(result) {
          this.$emit("updated")
        }     
      }

      this.loading--
    }
  }
}
</script>

<style lang="scss" scoped>
.cm-form {
  width: 320px;
  position: relative;
  background: white;

  &.container {
    background: #f5f5f5;
    box-shadow: 3px 3px 3px rgba(0,0,0,0.2);
  }
  

   // spinner div
  .cm-loader {
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: rgba(255,255,255, 0.7);
  }

  .cm-form-details {
     padding: 10px 20px 20px 20px;

     .cm-contact-list-actions {
       width: 100%;
       display: flex;
       justify-content: flex-end;
     }
  }

  h3 {
    margin: 0;
    padding: 10px 20px;
    font-weight: 700 !important;
    font-size: 14px !important;
    color: white;
    background: #24AB80;
    text-transform: uppercase;

    &.container {
      color: black;
      background: transparent;
    }
  }
}
</style>

